/**
 * Reporter d'erreurs front → monitoring maison (/v1/public/client-errors).
 * Capture window.onerror + unhandledrejection. Dédup + throttle local
 * pour éviter de spammer l'API en cas de boucle d'erreur.
 */
const API_BASE =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) ??
  "https://api.myvictor.fr";

const SOURCE = "agent";
const seen = new Map<string, number>();
const THROTTLE_MS = 60_000;

function report(message: string, stack?: string): void {
  if (!message) return;
  const key = `${message}::${(stack ?? "").split("\n")[1] ?? ""}`;
  const now = Date.now();
  const last = seen.get(key) ?? 0;
  if (now - last < THROTTLE_MS) return;
  seen.set(key, now);

  void fetch(`${API_BASE}/v1/public/client-errors`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      source: SOURCE,
      message: message.slice(0, 1000),
      stack: stack?.slice(0, 8000),
      path: window.location.pathname,
    }),
    keepalive: true,
  }).catch(() => undefined);
}

export function installErrorReporter(): void {
  window.addEventListener("error", (e) => {
    report(e.message || "Erreur JS", e.error?.stack);
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    report(
      reason?.message ?? String(reason) ?? "Promise rejetée",
      reason?.stack,
    );
  });
}
